import { wordTypeLabel, type WordType } from "../../domain/vocabulary/types.ts";
import styles from "../design-system/ui.module.css";

export function TypeTag({ type }: { type: WordType }) {
  return (
    <span className={styles.tag} data-type={type}>
      {wordTypeLabel(type)}
    </span>
  );
}
